import { Select, SelectProps } from 'antd';
import { useGetRecipeCategoriesQuery } from 'app/api';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IOption } from 'types';

interface IProps extends SelectProps<number> {}

const RecipeCategorySelect: FC<IProps> = props => {
  const { t } = useTranslation();

  const { data, isFetching } = useGetRecipeCategoriesQuery();

  const options: IOption[] | undefined = data?.map(recipeCategory => ({
    value: recipeCategory.id,
    label: recipeCategory.name,
  }));

  return (
    <Select
      loading={isFetching}
      options={options}
      placeholder={t('Recipe.RecipeCategorySelect', 'Recipe category')}
      {...props}
    />
  );
};

export default RecipeCategorySelect;
